import * as types from '../constants/action-types';

export function updateAddOnsIndex (index) {
  return {
    type: types.ADDONS_INDEX_UPDATE,
    index
  };
}

export function addItemtoAddItemsForm (item) {
  return {
    type: types.ADDONS_ADD_ITEM,
    item
  };
}

export function updateAddOnsStep (step) {
  return {
    type: types.ADDONS_STEP_UPDATE,
    step
  };
}
